import React from 'react'
import { useParams } from 'react-router-dom'
import Page from 'component/page-container'
import { YMaps, Map, Placemark, ZoomControl } from 'react-yandex-maps';
import { nl2br } from 'helpers'
import cs from 'classnames'
import './style.css'

/* global API */

const RecommendationRoute = () => {

    const [recommendation, setRecommendation] = React.useState({})
    const [isLiked, setIsLiked] = React.useState(0)

    const { recommendationId } = useParams()

    const handleLike = e => {
        API.instance().recommendation.setIsLiked(recommendationId, !isLiked ? 1 : 0).then(result => {
            if (result) {
                setIsLiked(!isLiked ? 1 : 0)
            }
        })
    }

    React.useEffect(() => {
        if (Object.keys(recommendation).length === 0) {
            API.instance().recommendation.get(recommendationId).then(data => {
                const isLiked = data.isLiked
                setRecommendation(data)
                setIsLiked(isLiked)
            })
        }

    }, [recommendationId, recommendation, isLiked])

    return (
        <Page
            className="recommendation-page"
            h1={recommendation.title}
            h1Label={
                recommendation.user?.name + ' ' +
                recommendation.user?.surname + ' рекомендует: ' +
                recommendation.category?.title
            }
        >
            <div className="page__inner">
                <div className="recommendation">
                    <div
                        className="recommendation__description"
                        dangerouslySetInnerHTML={{ __html: nl2br(recommendation.description) }}
                    />
                </div>
                {!!recommendation.linkList?.length &&
                    <div className="recommendation__link-list">
                        {recommendation.linkList.map(link =>
                            <div key={"link-" + link.id} className="recommendation__link">
                                <a href={link.link} target="_blank" rel="noreferrer">{link.link}</a>
                            </div>
                        )}
                    </div>
                }
                {(!!recommendation.telegramChannelMessageId) &&
                    <div className="container">
                        Комментарии добавляют <a
                            target="_blank"
                            rel="noreferrer"
                            href={
                                "https://t.me/c/" +
                                recommendation.process?.telegramChannelId.toString().substr(4) +
                                "/" + recommendation.telegramChannelMessageId
                            }
                        >к сообщению в Телеграме</a>.
                    </div>
                }

                {!!recommendation.location && <YMaps>
                    <div className="recommendation__map">
                        <Map
                            defaultState={{
                                center: [recommendation.location.latitude, recommendation.location.longitude],
                                zoom: 15
                            }}
                            width="100%"
                            height="400px"
                        >
                            <Placemark
                                geometry={[recommendation.location.latitude, recommendation.location.longitude]}
                            />
                            <ZoomControl />
                        </Map>
                    </div>
                </YMaps>}

                <i
                    className={cs(
                        "fa",
                        "fa-heart",
                        "like-button",
                        { "like-button_liked": isLiked }
                    )}
                    onClick={handleLike}
                />
            </div>
        </Page>
    )
}

export default RecommendationRoute

